/* eslint-disable class-methods-use-this */
import _ from 'lodash';

/**
 * Нормализация и реструктуризация ответов от сервера для src/common/reducers/listsCollection
 *
 * Пример:
 * arrayItems = [
 *  {
 *    id:1,
 *    child_array: [
 *      {
 *        id: 1,
 *        parent: 1,
 *        item_value: item1
 *      },
 *      {
 *        id: 2,
 *        parent: 1,
 *        item_value: item2
 *      },
 *    ]
 *  },
 *  {
 *    id:2,
 *    child_array: [
 *      {
 *        id: 3,
 *        parent: 2,
 *        item_value: item3
 *      },
 *      {
 *        id: 4,
 *        parent: 2,
 *        item_value: item4
 *      },
 *    ]
 *  }
 * ]
 *
 * normalize(arrayItems, 'child_array', restructureFunc, state, 'parent')
 * преобразуется в
 *
 * items: {
 *   1: {
 *     id: 1,
 *     parent: 1,
 *     item_value: item1
 *   },
 *   2: {
 *     id: 2,
 *     parent: 1,
 *     item_value: item2
 *   }
 *   3: {
 *     id: 3,
 *     parent: 2,
 *     item_value: item3
 *   }
 *   4: {
 *     id: 4,
 *     parent: 2,
 *     item_value: item4
 *   }
 * }
 *
 * map: {1: [1, 2], 2: [3, 4]}
 * */
// eslint-disable-next-line import/prefer-default-export
export class ArraysCollections {
  constructor() {
    this.items = {};
    this.map = {};
  }

  getItems() {
    return this.items;
  }

  getMap() {
    return this.map;
  }

  normalize(items, childKeyName, restructureFunc, state, groupByKey) {
    let list;
    if (childKeyName) {
      list = _.flatten(
        _.map(items, item =>
          _.map(_.get(item, childKeyName), children => children)
        )
      );
    } else {
      list = items;
    }

    this.items = _.keyBy(list.map(item => restructureFunc(state, item)), 'id');
    this.map = _.chain(list)
      .groupBy(groupByKey)
      .mapValues(item => _.map(item, children => _.get(children, 'id')))
      .value();
  }
}



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/normalize.js